<template>
  <div class="page">
    <Header :title="title" :showBack="true"></Header>

    <!-- 司机信息 -->
    <van-form>
      <van-cell-group>
        <van-field required label="手机号码：" v-model="driver.DriverTel" placeholder="请输入司机手机号码" label-align="left"
          type="number" maxlength="11" ref="drivertel" @blur="getDriver" :error-message="errMsg"
          :rules="[{ required: true, message: '请填写用户名' }]" />

        <van-field required label="司机姓名：" v-model="driver.DriverName" placeholder="请输入司机姓名" label-align="left"
          :disabled="isAllowUpdateName" right-icon="question-o"
          @click-right-icon="$toast('如需修改司机姓名请联系管理人员')"></van-field>
        <van-field required label="身份证号码：" v-model="driver.DriverCertNo" placeholder="请输入司机身份证号码" label-align="left"
          :disabled="isAllowUpdate" @blur="getIndustryCertNoInfo" type="number"></van-field>
        <van-field required label="从业资格证号：" v-model="driver.IndustryCertNo" placeholder="请输入从业资格证件号码" label-align="left"
          :disabled="isAllowUpdate" type="number"></van-field>
        <van-field name="IndustryCertFile" label="从业资格证" right-icon="question-o"
          @click-right-icon="$toast('添加附件用于系统核验')">
          <template #input>
            <van-uploader v-model="industryCertUploader" max-count="1" />
          </template>
        </van-field>

        <van-field label="备注：" v-model="driver.Remark" placeholder="请输入备注" label-align="left"></van-field>
      </van-cell-group>

      <!-- 确认按钮 -->
      <div class="footBtn">
        <van-row>
          <van-col span="12">
            <van-button type="default" block @click="doDriverSave">保存</van-button>
          </van-col>
          <van-col span="12">
            <van-button type="default" block @click="goBack">取消</van-button>
          </van-col>
        </van-row>
      </div>
    </van-form>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "司机信息",
      errMsg: "",
      isAllowUpdate: true,
      isAllowUpdateName: true,
      queryTel: "",
      driver: {
        DriverTel: null,
        DriverName: null,
        IndustryCertNo: null,
        DriverCertNo: null,
        Remark: null,
        CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
        IsVerified: false,

      }, //车辆信息
      industryCertUploader: [],
      driverGID: this.$route.query.GID, //司机GID
    };
  },
  methods: {
    //图片压缩
    afterReadImg(file) {
      if (!file) {
        return;
      }
      // 创建Canvas对象(画布)
      let canvas = document.createElement("canvas");
      // 获取对应的CanvasRenderingContext2D对象(画笔)
      let context = canvas.getContext("2d");
      // 创建新的图片对象
      let img = new Image();
      // 指定图片的DataURL(图片的base64编码数据)
      img.src = file.content;
      // 监听浏览器加载图片完成，然后进行进行绘制
      img.onload = () => {
        // 指定canvas画布大小，该大小为最后生成图片的大小
        canvas.width = 800;
        canvas.height = 600;
        /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/
        context.drawImage(img, 0, 0, 800, 600);
        // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
        file.content = canvas.toDataURL(file.file.type, 0.92);

        let params = {
          _JsonText: JSON.stringify({
            ObjectCode: "Driver",
            ObjectGID: this.driverGID,
            AttachmentType: '从业资格证',
            FileName: "从业资格证",
            UrlRelativePath: "",
            UrlAbsolutelPath: "",
            IsValid: true,
            ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
            ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode,
            ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName,
          }),
          base64Content: file.content,
        };
        this.$http
          .post(this.$api.onUploadAttachment, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              //file.content = res.data.UrlAbsolutelPath;
            }
          });
      };
    },

    //司机信息保存
    doDriverSave() {
      if (!this.driver.DriverTel) {
        this.$toast.fail("请输入手机号码");
        return;
      }
      if (!this.driver.DriverName) {
        this.$toast.fail("请输入司机姓名");
        return;
      }
      if (!this.driver.IndustryCertNo) {
        this.$toast.fail("请输入司机从业资格证号");
        return;
      }
      //保存
      let params = {
        _JsonText: this.driver,
      };
      params._JsonText.ModifyGID = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).GID;
      params._JsonText.ModifyCode = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).UserCode;
      params._JsonText.ModifyName = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).UserName;
      params._JsonText = JSON.stringify(params._JsonText);
      this.$http
        // .post(this.$api.onSaveDriver, this.$qs.stringify(params))
        .post(this.$api.onSaveDriver, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.driverGID = res.data.DriverGID
            //保存成功 如果上传了附件 新增附件
            if (this.industryCertUploader.length > 0) {
              this.afterReadImg(this.industryCertUploader[0])
            }
            //保存成功
            this.$toast.success("保存成功");
            this.$router.push({
              name: "VehicleHome",
              params: {
                driverTel: this.driver.DriverTel,
              },
            });
          }
        });
    },
    //返回上一页
    goBack() {
      history.back();
    },
    //获取司机从业资格证信息
    getIndustryCertNoInfo() {
      return;
      //如果输入的是非身份证件 不进行查询
      // if (!this.$utils.isCardNo(this.driver.DriverCertNo)) {
      //   return;
      // }
      // let params = {
      //   IdCard: this.driver.DriverCertNo,
      // };
      // this.$http
      //   .post(this.$api.onGetDriverIndustryCertNo, this.$qs.stringify(params))
      //   .then((res) => {
      //     if (res.success) {
      //       if (res.data.length > 0) {
      //         this.driver.DriverName = res.data[0].XingMing;
      //         this.driver.IndustryCertNo = res.data[0].CongYeZiGeZhengHao;
      //         this.driver.IsVerified = true;
      //       } else {
      //         this.driver.IsVerified = false;
      //         this.$toast.fail("未查询到对应司机信息");
      //       }
      //     }
      //   });
    },
    //获取基础司机信息
    getDriver() {
      //校验手机号码
      if (!this.$utils.isPhone(this.driver.DriverTel)) {
        this.errMsg = "手机号码格式错误";
        return;
      } else {
        this.errMsg = "";
      }
      if (this.driver.DriverTel == this.queryTel) {
        return;
      }
      this.queryTel = this.driver.DriverTel;
      let params = {
        DriverTel: this.driver.DriverTel,
      };
      this.$http
        .post(this.$api.onGetDirver, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            if (res.data.length > 0) {
              this.isAllowUpdate = true;
              this.isAllowUpdateName = true;
              this.driver.DriverName = res.data[0].DriverName;
              this.driver.IndustryCertNo = res.data[0].IndustryCertNo;
              this.driver.DriverCertNo = res.data[0].DriverCertNo;
              this.driver.IsVerified = res.data[0].IsVerified;
            } else {
              this.driver.DriverName = null;
              this.driver.IndustryCertNo = null;
              this.driver.DriverCertNo = null;
              this.driver.IsVerified = false;
              this.isAllowUpdateName = false;
              this.isAllowUpdate = false;
              this.isAllowUpdateName = false;
            }
          }
        });
    },
    //获取司机信息
    getDriverInfo() {
      let params = {
        GID: this.driverGID,
      };
      this.$http
        .post(this.$api.onCompDriverQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.driver = res.data[0];
            if (res.data[0].AttachmentUrl) {
              this.industryCertUploader.push({
                url: res.data[0].AttachmentUrl
              });
            }
            this.$refs.drivertel.focus();
          }
        });
    },
  },
  mounted: function () { },
  created() {
    this.driverGID = this.$route.query.GID;

    if (this.driverGID) {
      this.getDriverInfo();
    }
  },
};
</script>

<style scoped lang="less">
.footBtn {
  position: absolute;
  width: 100%;
  bottom: 0rem;
}

.page {
  text-align: left;
}
</style>
